<template>
	<ul class="m-product-list">
		<li v-for="(item, i) in unitData.product_list" :key="item.product_id" class="flex-center">
			<sub-image class="image" :src="item.product_img_url"></sub-image>
			<div class="info flex-grow">
				<p class="name ellipsis-3">{{item.product_name}}</p>
				<div class="price">
					<span>￥<strong>{{parseFloat(item.sale_price)}}</strong></span>
				</div>
			</div>
		</li>
	</ul>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-list {
		padding: 16px 10px;
		
		li {
			box-sizing: border-box;
			height: 196px;
			padding: 0 14px;
			background-image: url('~@/assets/image/decorate/product_list/bg.png');
			background-size: 100%;
			
			&:nth-child(n+2) {
				margin-top: 16px;
			}
			
			.image {
				width: 160px;
				height: 160px;
				border-radius: 4px;
				padding: 3px;
				margin-right: 16px;
				background-image: url('~@/assets/image/decorate/product_list/image.jpg') !important;
				background-size: 100% !important;
			}
			
			.info {
				.name {
					height: 72px;
					line-height: 24px;
					font-size: 16px;
					color: #FFF8C9;
				}
				
				.price {
					box-sizing: border-box;
					width: 150px;
					height: 48px;
					padding-left: 12px;
					margin-top: 30px;
					font-size: 15px;
					background-image: url('~@/assets/image/decorate/product_list/price.png');
					background-size: 100%;
					
					span {
						display: inline-block;
						line-height: 48px;
						color: transparent;
						background: linear-gradient(-45deg, #FCC681 0%, #FEE7C0 100%);
						background-clip: text;
						-webkit-background-clip: text;
						filter: drop-shadow(rgba(21,86,85,0.39) -1px 2px 1px);
					}
					
					strong {
						font-size: 28px;
					}
				}
			}
		}
	}
</style>
